// eslint-disable-next-line import/no-cycle
import NetworkAdmin from '@/helpers/networking/NetworkAdmin';
// eslint-disable-next-line import/no-cycle
import usersService from '@/services/usersService';
// eslint-disable-next-line import/no-cycle
import NetworkContent from '@/helpers/networking/NetworkContent';

export default {
  state: {
    // Content Management variables (from users store)
    users: [],
    loading: false,
    error: null,

    // UserAdministrationComponent variables
    allActiveUsers: [],
    allActiveUsersCount: 0,
    allCheckedUsers: [],
    filterTags: [],
    filterTeams: [],
    filterWorkshops: [],
    startDate: '',
    endDate: '',
    minLevel: '',
    maxLevel: '',
    usersPerPage: 10,
    currentPage: 1,

    // UserAdministrationComponent sort variables
    sortByName: 0,
    sortByLevel: 0,
    sortByEmail: 0,
    sortByLastActivity: 0,

    // SuperUserProfileOverlayComponent variables
    superUserProfileInfo: null,
    superUserProfileTags: [],
    superUserProfileTasks: [],
    superUserProfileCompletedTasks: [],
    superUserProfileOmindWorkshops: [],
    superUserProfileCurrentLevelProgress: null,

    // UserAdministrationFilterComponent variables
    filterDataTags: [],
    filterDataTeams: [],
    filterDataOmindWorkshops: [],
    availableSchemas: [],
  },
  getters: {
    getAllActiveUsers: (state) => state.allActiveUsers,
    getAllActiveUsersCount: (state) => state.allActiveUsersCount,
    getAllCheckedUsers: (state) => state.allCheckedUsers,
    getFilterTags: (state) => state.filterTags,
    getFilterTeams: (state) => state.filterTeams,
    getFilterWorkshops: (state) => state.filterWorkshops,
    getStartDate: (state) => state.startDate,
    getEndDate: (state) => state.endDate,
    getMinLevel: (state) => state.minLevel,
    getMaxLevel: (state) => state.maxLevel,

    getUsersPerPage: (state) => state.usersPerPage,
    getCurrentPage: (state) => state.currentPage,

    getSortByName: (state) => state.sortByName,
    getSortByLevel: (state) => state.sortByLevel,
    getSortByEmail: (state) => state.sortByEmail,
    getSortByLastActivity: (state) => state.sortByLastActivity,

    isCheckedUser: (state) => (userId) => state.allCheckedUsers.some((user) => user._id === userId),
    getCheckedUsersCount: (state) => state.allCheckedUsers.length,

    superUserProfileInfo: (state) => state.superUserProfileInfo,
    superUserProfileTags: (state) => state.superUserProfileTags,
    superUserProfileTasks: (state) => state.superUserProfileTasks,
    superUserProfileCompletedTasks: (state) => state.superUserProfileCompletedTasks,
    superUserProfileOmindWorkshops: (state) => state.superUserProfileOmindWorkshops,
    superUserProfileCurrentLevelProgress: (state) => state.superUserProfileCurrentLevelProgress,

    filterDataTags: (state) => state.filterDataTags,
    filterDataTeams: (state) => state.filterDataTeams,
    filterDataOmindWorkshops: (state) => state.filterDataOmindWorkshops,
    // Use assessmentSchemas store for real-time updates when canBeCreatedByAdmin is toggled
    getAvailableSchemas: (state, getters, rootState) => {
      const schemas = rootState.assessmentSchemas?.assessmentSchemas || [];
      return schemas.filter((schema) => schema.config?.adminCreation?.canBeCreatedByAdmin === true);
    },
  },
  mutations: {
    // Content Management mutations (from users store)
    setLoading(state, val) {
      state.loading = val;
    },
    setError(state, err) {
      state.error = err;
    },
    setUsers(state, users) {
      state.users = users;
    },
    updateUser(state, { userId, roles }) {
      const user = state.users.find((u) => u._id === userId);
      if (user) user.roles = roles;
    },
    updateUserReflexionGuideline(state, { userId, reflexionGuidelineActivated }) {
      const user = state.users.find((u) => u._id === userId);
      if (user) user.reflexionGuidelineActivated = reflexionGuidelineActivated;
    },
    updateUserTravelBuddyActivated(state, { userId, travelBuddyActivated }) {
      const user = state.users.find((u) => u._id === userId);
      if (user) {
        if (!user.travelBuddySystem) user.travelBuddySystem = {};
        user.travelBuddySystem.activated = travelBuddyActivated;
      }
    },
    updateUserExternalEvaluation(state, { userId, externalEvaluationEnabled }) {
      const user = state.users.find((u) => u._id === userId);
      if (user) user.externalEvaluationEnabled = externalEvaluationEnabled;
    },
    updateMultipleUsersExternalEvaluation(state, { userIds, externalEvaluationEnabled }) {
      if (userIds.length === 0) {
        // Update all users
        state.users.forEach((user) => {
          // eslint-disable-next-line no-param-reassign
          user.externalEvaluationEnabled = externalEvaluationEnabled;
        });
      } else {
        // Update specific users
        userIds.forEach((userId) => {
          const user = state.users.find((u) => u._id === userId);
          // eslint-disable-next-line no-param-reassign
          if (user) user.externalEvaluationEnabled = externalEvaluationEnabled;
        });
      }
    },
    // User Administration mutations
    setAllActiveUsers: (state, data) => {
      state.allActiveUsers = data;
    },
    setAllActiveUsersCount: (state, count) => {
      state.allActiveUsersCount = count;
    },
    setCheckedUsers: (state, users) => {
      state.allCheckedUsers = users;
    },
    addCheckedUser: (state, user) => {
      state.allCheckedUsers.push(user);
    },
    removeCheckedUser: (state, userId) => {
      state.allCheckedUsers = state.allCheckedUsers.filter((user) => user._id !== userId);
    },
    checkAllUsers: (state, users) => {
      state.allCheckedUsers = users.slice();
    },
    uncheckAllUsers: (state) => {
      state.allCheckedUsers = [];
    },
    updateFilters: (
      state,
      {
        tagIds, teamIds, workshopIds, startDate, endDate, minLevel, maxLevel,
      },
    ) => {
      state.filterTags = tagIds;
      state.filterTeams = teamIds;
      state.filterWorkshops = workshopIds;
      state.startDate = startDate;
      state.endDate = endDate;
      state.minLevel = minLevel;
      state.maxLevel = maxLevel;
    },
    updateUsersPerPage: (state, usersPerPage) => {
      state.usersPerPage = usersPerPage;
    },
    updateCurrentPage: (state, currentPage) => {
      state.currentPage = currentPage;
    },
    setSuperUserProfileInfo(state, {
      user, dataTags, openTasks, completedTasks, omindWorkshops, currentLevelProgress,
    }) {
      state.superUserProfileInfo = user;
      state.superUserProfileTags = dataTags;
      state.superUserProfileTasks = openTasks;
      state.superUserProfileCompletedTasks = completedTasks;
      state.superUserProfileOmindWorkshops = omindWorkshops;
      state.superUserProfileCurrentLevelProgress = currentLevelProgress;
    },
    setFilterData(state, {
      tags, teams, omindWorkshops, schemas,
    }) {
      state.filterDataTags = tags;
      state.filterDataTeams = teams;
      state.filterDataOmindWorkshops = omindWorkshops;
      state.availableSchemas = schemas;
    },
    updateStoreState(state, { fieldName, newValue }) {
      state[fieldName] = newValue;
    },
  },
  actions: {
    // Content Management actions (from users store)
    async loadUsers({ commit, dispatch }) {
      commit('setLoading', true);
      commit('setError', null);
      try {
        const users = await usersService.fetchUsers();
        commit('setUsers', users);
      } catch (err) {
        commit('setError', err);
        dispatch(
          'notifications/showToast',
          {
            detail: 'Failed to fetch users.',
            severity: 'error',
          },
          { root: true },
        );
      } finally {
        commit('setLoading', false);
      }
    },

    async updateUser({ commit, dispatch }, { userId, roles }) {
      try {
        await usersService.updateUser(userId, roles);
        commit('updateUser', { userId, roles });

        dispatch(
          'notifications/showToast',
          {
            detail: 'Roles updated successfully',
            severity: 'success',
          },
          { root: true },
        );
      } catch (err) {
        console.error('Failed to update user roles:', err);
        commit('setError', err);
        const msg =
          err.response?.data?.message
          || err.response?.data?.error
          || 'Failed to update roles for user';
        dispatch(
          'notifications/showToast',
          {
            detail: typeof msg === 'string' ? msg : 'Failed to update roles for user',
            severity: 'error',
          },
          { root: true },
        );
        throw err;
      }
    },

    async updateUserReflexionGuideline(
      { commit, dispatch },
      { userId, reflexionGuidelineActivated },
    ) {
      try {
        await usersService.updateReflexionGuidelineActivated(userId, reflexionGuidelineActivated);
        commit('updateUserReflexionGuideline', { userId, reflexionGuidelineActivated });

        dispatch(
          'notifications/showToast',
          {
            detail: 'Reflection guideline status updated successfully',
            severity: 'success',
          },
          { root: true },
        );
      } catch (err) {
        console.error('Failed to update reflection guideline status:', err);
        commit('setError', err);
        dispatch(
          'notifications/showToast',
          {
            detail: 'Failed to update reflection guideline status',
            severity: 'error',
          },
          { root: true },
        );
      }
    },

    async updateUserTravelBuddyActivated(
      { commit, dispatch },
      { userId, travelBuddyActivated },
    ) {
      try {
        await usersService.updateTravelBuddyActivated(userId, travelBuddyActivated);
        commit('updateUserTravelBuddyActivated', { userId, travelBuddyActivated });

        dispatch(
          'notifications/showToast',
          {
            detail: 'Travel buddy status updated successfully',
            severity: 'success',
          },
          { root: true },
        );
      } catch (err) {
        console.error('Failed to update travel buddy status:', err);
        commit('setError', err);
        dispatch(
          'notifications/showToast',
          {
            detail: 'Failed to update travel buddy status',
            severity: 'error',
          },
          { root: true },
        );
      }
    },

    async setExternalEvaluationEnabled({ commit }, { userIds, setTo }) {
      const result = await usersService.setExternalEvaluationEnabled({ userIds, setTo });
      commit('updateMultipleUsersExternalEvaluation', { userIds, externalEvaluationEnabled: setTo });
      return result;
    },

    async generateTestData({ dispatch }, userId) {
      try {
        const result = await usersService.generateTestData(userId);
        return result;
      } catch (err) {
        dispatch('notifications/showToast', {
          detail: 'Failed to generate test data',
          severity: 'error',
        }, { root: true });
        throw err;
      }
    },

    async generateKssTestData({ dispatch }, payload) {
      try {
        const { data } = await NetworkContent.generateKssTestData(payload);
        return data;
      } catch (err) {
        dispatch('notifications/showToast', {
          detail: 'Failed to generate KSS test data',
          severity: 'error',
        }, { root: true });
        throw err;
      }
    },

    async removeKssTestData({ dispatch }) {
      try {
        const { data } = await NetworkContent.removeKssTestData();
        return data;
      } catch (err) {
        dispatch('notifications/showToast', {
          detail: 'Failed to remove KSS test data',
          severity: 'error',
        }, { root: true });
        throw err;
      }
    },

    // User Administration actions
    async getAllFilteredUsers({ state, commit }) {
      const postData = {
        tagIds: state.filterTags.map((item) => item._id),
        teamIds: state.filterTeams.map((item) => item._id),
        workshopIds: state.filterWorkshops.map((item) => item._id),
        startDate: state.startDate,
        endDate: state.endDate,
        minLevel: state.minLevel,
        maxLevel: state.maxLevel,
        currentPage: state.currentPage,
        sortByName: state.sortByName,
        sortByLevel: state.sortByLevel,
        sortByEmail: state.sortByEmail,
        sortByLastActivity: state.sortByLastActivity,
      };

      const { data } = await NetworkAdmin.postFilteredUsers(postData);
      commit('setAllActiveUsersCount', data.filteredUsersCount);
      commit('setAllActiveUsers', data.data);
    },
    async deleteUser(_, data) {
      await NetworkAdmin.deleteUser(data);
    },
    addCheckedUser({ commit }, user) {
      commit('addCheckedUser', user);
    },
    removeCheckedUser({ commit }, userId) {
      commit('removeCheckedUser', userId);
    },
    checkAllUsers({ commit }, users) {
      commit('checkAllUsers', users);
    },
    uncheckAllUsers({ commit }) {
      commit('uncheckAllUsers');
    },
    updateFilters(
      { commit },
      {
        tagIds, teamIds, workshopIds, startDate, endDate, minLevel, maxLevel,
      },
    ) {
      commit('updateFilters', {
        tagIds,
        teamIds,
        workshopIds,
        startDate,
        endDate,
        minLevel,
        maxLevel,
      });
    },
    updateUsersPerPage({ commit }, usersPerPage) {
      commit('updateUsersPerPage', usersPerPage);
    },
    updateCurrentPage({ commit }, currentPage) {
      commit('updateCurrentPage', currentPage);
    },
    async fetchSuperUserProfileInfo({ commit }, { userId, lang }) {
      try {
        const { data } = await NetworkAdmin.getDetailedUserInfos(userId, lang);
        const returnData = data.data[0];
        commit('setSuperUserProfileInfo', returnData);
      } catch (error) {
        console.error('Error fetching super user profile info:', error);
      }
    },
    async fetchFilterData({ commit }) {
      try {
        const { data } = await NetworkAdmin.getFilterComponentData();
        commit('setFilterData', data.data);
      } catch (error) {
        console.error('Error fetching filter data:', error);
      }
    },
  },
};
